export type TimekeeperEmployeeAction =
    | 'add'
    | 'edit'
    | 'deactivate'
    | 'assign-contract'
    | 'assign-position'
    | 'assign-tag'
    | 'assign-accrual-profile'
    | 'assign-schedule-rule'
    | 'assign-pay-rule';

export interface TimekeeperEmployeeActionRoute {
    action: TimekeeperEmployeeAction | null;
    id: number | null;
}

const BASE_PATH = '/timekeeper/employees';

const VALID_ACTIONS: TimekeeperEmployeeAction[] = [
    'add',
    'edit',
    'deactivate',
    'assign-contract',
    'assign-position',
    'assign-tag',
    'assign-accrual-profile',
    'assign-schedule-rule',
    'assign-pay-rule',
];

export const buildTimekeeperEmployeeBasePath = (): string => BASE_PATH;

export const buildTimekeeperEmployeeActionPath = (action: TimekeeperEmployeeAction, id?: number | string): string => {
    if (id === undefined || id === null || id === '') {
        return `${BASE_PATH}/${action}`;
    }

    return `${BASE_PATH}/${action}/${id}`;
};

export const parseTimekeeperEmployeeActionRoute = (pathname: string): TimekeeperEmployeeActionRoute => {
    const segments = pathname.split('/').filter(Boolean);

    if (segments[0] !== 'timekeeper' || segments[1] !== 'employees') {
        return { action: null, id: null };
    }

    const action = segments[2] as TimekeeperEmployeeAction | undefined;
    if (!action || !VALID_ACTIONS.includes(action)) {
        return { action: null, id: null };
    }

    const rawId = segments[3];
    if (!rawId) {
        return { action, id: null };
    }

    if (!/^\d+$/.test(rawId)) {
        return { action, id: null };
    }

    return { action, id: Number(rawId) };
};
